import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { RequestIndentCRUD } from '../services/requestIndentService';

const useRequestIndentCRUD = (callError) => {
    const processIndent = useCallback(async (selectedMode, editRequestIndentID, requestBody) => {
        try {
            const apiEndpoint = (selectedMode === 0 ||selectedMode === 53 )
                ? API_ENDPOINTS.REQUEST_INDENT_CRUD_PROCESS
                : API_ENDPOINTS.APPROVED_INDENT_CRUD_PROCESS;

            const successMessage = (selectedMode === 0 ||selectedMode === 53 )
                ? (editRequestIndentID !== 0 
                    ? 'Request indent updated Successfully' 
                    : 'New Request indent Created Successfully')
                : 'Request indent Approved Successfully';

            // Await the API response
            const data = await RequestIndentCRUD(apiEndpoint, requestBody);
            
            if (data?.length > 0) {
                callError('info', successMessage, 'info');
            } else {
                callError('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callError('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callError]);

    return { processIndent };
};

export default useRequestIndentCRUD;

